export default __webpack_public_path__ + "static/media/history-redo.693c485f.svg";